import { Placement } from '@popperjs/core';
import styled, { css } from 'styled-components';

export const StyledDropListWrapper = styled.div<{ isUnionControlGroup: boolean }>`
  position: relative;
  ${({ isUnionControlGroup }) => isUnionControlGroup && css`
    display: inline;
    &:first-child {
      button {
        border-top-left-radius: ${({ theme }) => theme?.Input?.borderRadius};
        border-bottom-left-radius: ${({ theme }) => theme?.Input?.borderRadius};
      }
    }
    &:nth-last-child(1) {
      button {
        border-top-right-radius: ${({ theme }) => theme?.Input?.borderRadius};
        border-bottom-right-radius: ${({ theme }) => theme?.Input?.borderRadius};
      }
    }
  `};
`;

export const StyledDropListContainer = styled.div<{
  isOpened: boolean;
  isBlurring: boolean;
  busy: boolean;
  maxPopperHeight: number;
  placement: Placement;
}>`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: ${({ theme }) => theme?.Input?.borderRadius};
  background: ${({ theme }) => theme.colors.white};
  z-index: 1000000;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.gray13};
  box-sizing: border-box;
  font-size: ${({ theme }) => theme.fontSize.base}px;
  
  ${({ isOpened }) => !isOpened && css`
    left: -10000000px !important;
    top: -10000000px !important;
  `}

  ${({ isBlurring }) => isBlurring && css`
    opacity: 0;
  `}
  
  ${({ isOpened }) => isOpened && css<{ maxPopperHeight: number }>`
    max-height: ${({ maxPopperHeight }) => maxPopperHeight}px;
  `}

  ${({ placement }) => placement === 'top' && css`
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-width: 1px 1px 0 1px;
    box-shadow: 0 -2px 4px ${({ theme }) => theme.colors.shadowGray1};
    `}
    
    ${({ placement }) => placement === 'bottom' && css`
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-width: 0 1px 1px 1px;
    box-shadow: 0 2px 4px ${({ theme }) => theme.colors.shadowGray1};
  `}

  ${({ busy }) => busy && css`
    &::after {
      position: absolute;
      content: '';
      inset: 0 0 0 0;
      background: rgba(255, 255, 255, .65);
      z-index: 1;
    }
  `}
`;

export const StyledDropListScrollWrapper = styled.ul`
  flex: 1;
  padding: 0;
  margin: 0;
  overflow: auto;
  overscroll-behavior: none;
  -ms-scroll-chaining: none;
  -webkit-overflow-scrolling: touch;
`;

export const StyledDropListItem = styled.li<{
  isFocused: boolean;
  isEmpty: boolean;
}>`
  min-height: 40px;
  padding: 11px 12px;
  margin: 0;
  box-sizing: border-box;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;

  &:hover, &:hover mark {
    background-color: ${({ theme }) => theme.colors.blue12};
    color: ${({ theme }) => theme.colors.light};
  }

  ${({ isFocused }) => isFocused && css`
    background: ${({ theme }) => theme.colors.blue14};
    color: ${({ theme }) => theme.colors.primary};
    mark {
      background: ${({ theme }) => theme.colors.blue14};
      color: ${({ theme }) => theme.colors.primary};
    }
  `}

  ${({ isEmpty }) => isEmpty && css`
    color: ${({ theme }) => theme.colors.shadowGray4};
    mark {
      color: ${({ theme }) => theme.colors.shadowGray4};
    }
  `}
`;
